export const types = {
  SET_PRODUCTS: "SET_PRODUCTS",
};
